import { ProfileCardDescription } from '@seek/profile-base-ui';
import { Box, Divider, Text } from 'braid-design-system';
import React from 'react';

import { SUMMARY } from 'src/components/Router';

import { useShareableProfile } from '../data';

export const Summary = () => {
  const { shareableProfile, shareableProfileCardEmpty } = useShareableProfile();
  const summary = shareableProfile?.summary || '';

  return shareableProfileCardEmpty[SUMMARY] ? null : (
    <>
      <Box id={SUMMARY} paddingBottom="xxlarge" data-automation={SUMMARY}>
        <Text>
          <ProfileCardDescription
            text={summary}
            replaceUrlTextWithLinks={false}
          />
        </Text>
      </Box>
      <Divider weight="regular" />
    </>
  );
};
